import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import usersApi from "../../api/userApi";
import Pagination from "../../components/Pagination";

const MasterAdmin = () => {
  const navigate = useNavigate();
  const [masterAdmins, setMasterAdmins] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchMasterAdmins();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchMasterAdmins = async () => {
    try {
      const response = await usersApi.getUsersList(
        page,
        pageSize,
        sortedColumn,
        sortOrder,
        "MASTER_ADMIN",
      );
      setMasterAdmins(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching master admins:", error);
      setMasterAdmins([]);
      setTotalPages(0);
      console.error("Error fetching master admins", error);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };

  return (
    <div>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          {masterAdmins.map((masterAdmin, index) => (
            <tr key={masterAdmin.userId}>
              <td>{masterAdmin.userId}</td>
              <td>{masterAdmin.userName}</td>
              <td>{masterAdmin.userEmail}</td>
              <td>{masterAdmin.countryName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {masterAdmins.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};

export default MasterAdmin;
